import apiClient from './apiClient'


const getPlaceholdersScheduleGlobal = (tenant) => {
  return apiClient.get(`/${tenant}/Placeholder/schedule/global`)
}

const getPlaceholdersContractGlobal = (tenant) => {
  return apiClient.get(`/${tenant}/Placeholder/contract/global`)
}

const getPlaceholdersContractContact = (tenant) => {
  return apiClient.get(`/${tenant}/Placeholder/contract/contact`)
}

const getPlaceholdersContractVenue = (tenant) => {
  return apiClient.get(`/${tenant}/Placeholder/contract/venue`)
}


export default {
  getPlaceholdersScheduleGlobal,
  getPlaceholdersContractGlobal,
  getPlaceholdersContractContact,
  getPlaceholdersContractVenue
}
